import React, { useEffect, useState } from 'react'
import useHttp from '../../../hooks/use-http';
import Input from "../../UI/Input";
import { endPoints } from "../../../config/end-points"
import { cuteToast } from '../../UI/cute';
import { useDispatch } from 'react-redux';
import { settingAction } from "../../../store/setting-store";

const APIs = () => {

    const {sendRequest: insertApiKeys} = useHttp();
    const {sendRequest: getSettingData} = useHttp();
    const dispatch = useDispatch();

    const [keys, setKeys] = useState({
        googleApiKey: "",
        yelpApiKey: "",
    });

    useEffect(()=>{
        // console.log('here setting')
        getSettingData({
            url: endPoints.getSettingData,
            method: "GET",
        },(response)=>{
            // console.log(response)
            if(response.status === 200 && response.body.length > 0){
                // console.log(response.body)
                const result = response.body
                const API_Data = result.filter((data)=>data.meta_type === "API_KEYS");
                const meta_data = JSON.parse(API_Data[0].meta_data)
                if(meta_data){
                    setKeys(meta_data)
                    dispatch(settingAction.setAPIkeys({ api_keys:meta_data}));
                }
            }
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const formHandler = (event) => {
        event.preventDefault();
        dispatch(settingAction.setAPIkeys({ api_keys:keys}));

        insertApiKeys({
            url: endPoints.updateApiStting,
            method: "POST",
            body: {
                ...keys,
                type:"API_KEYS"
            },
        },(response)=>{
            if(response.status === 200){
                cuteToast({
                    type: "success",
                    message: "Saved Successfully.",
                    timer: 5000,
                    title: "API Key Settings",
                  });
            }
        })
    }
    
  return (
    <div className="col-md-12 mb-4">
        <div className="bx_a">
            <form onSubmit={formHandler}>
                <h5 className="mb-4 pb-3 small_title d-flex">
                    API Settings
                </h5>
                <h6 className="small_title d-flex">
                    Google API:
                </h6>
                <div className="form-row row">
                    <div className="form-group col-md-6">
                        <label htmlFor="inputName" className='h6 d-none'>API KEY:</label>
                        <Input
                            type="password"
                            inputClass="form-control"
                            value={keys.googleApiKey}
                            id="inputName"
                            placeholder="Enter Your Google API Key"
                            onChange={(e) =>
                                setKeys({ ...keys, googleApiKey: e.target.value })
                            }
                        />
                    </div>
                </div>

                <h6 className="small_title d-flex mt-3">
                    Yelp API:
                </h6>
                <div className="form-row row">
                    <div className="form-group col-md-6">
                        <label htmlFor="inputName" className='h6 d-none'>API KEY:</label>
                        <Input
                            type="password"
                            inputClass="form-control"
                            value={keys.yelpApiKey}
                            id="inputName"
                            placeholder="Enter Your Yelp API Key"
                            onChange={(e) =>
                                setKeys({ ...keys, yelpApiKey: e.target.value })
                            }
                        />
                    </div>
                </div>
                
            
                <div className="form-group d-flex justify-content-end">
                    <button className='btn mt-4 w-25' type='submit'>Save Details</button>
                </div>  
            </form>
        </div>
    </div>
  )
}

export default APIs